import React from 'react'
import { Box, Paper, Skeleton, Stack } from '@mui/material'
import { ApiTableSkeleton } from '@e3dc-react/shell/Elements/Skeletons'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  cardSkeleton: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
  },
  filterSkeleton: {
    borderRadius: theme.spacing(theme.shape.borderRadius),
    height: 30,
    width: 120,
  },
}))

/** Skeleton component for loading tariffs state */
export const TariffSkeleton = (): JSX.Element => {
  const { classes, cx } = useStyles()

  return (
    <>
      <Stack direction="row" justifyContent={'flex-end'} alignItems={'center'} pb={2}>
        <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
      </Stack>

      <Box className={classes.tableContainer}>
        <Paper>
          <ApiTableSkeleton columnAmount={5} withFilter={false} />
        </Paper>
      </Box>
    </>
  )
}
